import { apiClient } from "../service/tekkr-service";
import { useMutation } from "@tanstack/react-query";
import { AssistantTonePreferences } from "tekkr-common/dist/model/user/tone";
import { Persona } from "tekkr-common/dist/model/user/persona";

interface Input {
    userId: string;
    name?: string;
    title?: string;
    department?: string;
    assistantTonePreferences?: AssistantTonePreferences;
    persona?: Persona;
}

interface Options {
    onSuccess?: () => void;
}

export function useUpdateOrgUserMutation(options?: Options) {
    return useMutation({
        mutationFn: async (input: Input) => {
            await apiClient.updateOrgUser({
                params: { userId: input.userId },
                body: {
                    name: input.name,
                    title: input.title,
                    department: input.department,
                    assistantTonePreferences: input.assistantTonePreferences,
                    persona: input.persona,
                },
            });
        },
        onSuccess: options?.onSuccess,
    });
}
